// TOGGLE AUTO APPLY ******************************************************************************
// pathname: /v1/user-subscription/toggle-auto-apply
// ************************************************************************************************
import {
  useSwrMutationApi,
} from 'src/hooks/useSwrApi';

/**
 * @description SWR mutation: toggle auto apply. Used to enable / disable auto-apply feature for
 * premium talents. Since we're not sending any payload, we're using undefined as the type for
 * the payload.
 * @param locale
 */
export const useSwrToggleAutoApply = (locale = 'ro') => {
// SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: '/v1/user-subscription/toggle-auto-apply',
    locale,
    fetcherConfig: {
      method: 'PUT',
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
